import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';

import { ModalDirective } from 'ngx-bootstrap/modal';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

import { StoreFacade } from '../../../common/facade/StoreFacade';
import { Shipment } from '../../../common/model/Shipment';
import { ShipmentFacade } from '../../../common/facade/ShipmentFacade';
import { Permissions } from '../../../common/model/dictionary/Permissions';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { DateFormatPipe } from '../../../common/util/date-format.pipe';
import { ShipmentManifest } from '../../../common/model/ShipmentManifest';
import { ShipmentManifestFacade } from '../../../common/facade/ShipmentManifestFacade';
import { ComboMultiSelectComponent } from '../../../containers/combo-multi-select/combo-multi-select.component';
import { Organization } from '../../../common/model/Organization';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';

@Component({
  selector: 'app-shipments',
  templateUrl: './shipments.component.html',
  styleUrls: ['./shipments.component.css']
})
export class ShipmentsComponent implements OnInit {
  @ViewChild('detailGuides') public detailGuides: ModalDirective;
  @ViewChild('createModal') public createModal: ModalDirective;
  @ViewChild('sheetNumberModal') public sheetNumberModal: ModalDirective;

  loading = false;
  messageLoader = '';
  // alert
  alerts = [];
  storeId = -1;
  tmpStoreId = -1;
  organizationId = null;
  stores: any[] = [];
  rows: Shipment[];
  private _filteredData: Shipment[];
  hideStores = false;
  titleDelivery = '';
  manifests: ShipmentManifest[];
  sheetNumbers: string[] = [];
  endDate = new Date();
  startDate = new Date();
  public res = res;
  isSpanish = true;

  titleCEDISMerchandiseEntry = res.CEDISMerchandiseEntry;

  lblStartDate = res.StartDate;
  lblEnd = res.EndDate;
  lblSelectStore = res.SelectStore;
  lblSelectAnOption = res.SelectAnOption;
  lblSearch = res.Search;
  lblSent = res.Sent;
  lblEndDate = res.EndDate;
  lblMerchandiseDetail = res.MerchandiseDetail;
  lblShippingNumberDetail = res.ShippingNumberDetail;
  lblView = res.View;
  lblFinishedA = res.FinishedA;
  lblProcess = res.Process;
  lblClose = res.Close;

  lblProvider = res.Provider;
  lblDelivery = res.Delivery;
  lblInvoice = res.Invoice;
  lblStore = res.Store;
  lblSendDate = res.SendDate;
  lblAmountSent = res.AmountSent;
  lblSheetNumber = res.FolioTransferEntryTitle;
  lblReceivedDate = res.ReceivedDate;
  lblEntryDate = res.EntryDate;
  lblAmountEntry = res.AmountEntry;
  lblDiffAmountSentEntry = res.DiffAmountSentEntry;
  lblReceived = res.Received;
  lblEntry = res.Entry;
  lblDaysReceivedEntry = res.DiffDaysReceivedEntry;
  lblDaysSentReceived = res.DiffDaysSentReceived;
  lblNumberGuide = res.GuideNumber;
  lblDownload = res.Download;
  lblStatus = res.Status;
  lblDetail = res.Detail;
  lblShippingGuides = res.DetailShipmentGuides;
  lblInConsigment = res.Expiration;
  lblPartial = res.PartialEntry;
  lblCompleted = res.CompleteEntry;
  lblUnknown = res.UnknownStatus;

  //ComboOrganizacion
  public TenantId = 0;
  public organizationList: Organization[] = [];
  public AvailableOrganizations: Organization[] = [];
  public selectedOrganization: Organization[] = [];
  public strOrganizationSelected: string;
  public strStores: string;
  public botonEnable: boolean;
  public ImStore: boolean = false;
  @ViewChild(ComboMultiSelectComponent) cmbMultiSelect;
  public organizationSelected: any[] = [];

  messagesTable: any = {
    emptyMessage: '',
    totalMessage: ''
  };
  organizations: Organization[];
  organizationUSA = 'US30'

  /**
   * Create a new instance of the class.
   * 
   * @param _facade 
   * @param _facadeStore 
   * @param _router 
   * @param _route 
   * @param _storage 
   * @param _excel 
   * @param _dateFormat 
   * @param _datePipe 
   * @param _facadeShipmentManifest 
   * @param strings 
   */
  constructor(
    private _facade: ShipmentFacade,
    private _facadeStore: StoreFacade,
    private _router: Router,
    private _route: ActivatedRoute,
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private _excel: ExcelUtility,
    private _dateFormat: DateFormatPipe,
    private _datePipe: DatePipe,
    private _facadeShipmentManifest: ShipmentManifestFacade,
    public strings: Strings,
    private localeService: BsLocaleService
  ) {
    this._storage.set('moduleUrl', this._router.url);
    const d = new Date();
    d.setDate(d.getDate() - 15);
    this.startDate = d;
  }

  /**
   * This event allows us to execute more complex initializations such as fetching data.
   */
  ngOnInit() {
    this.messageLoader = this.strings.GetText(res.Loading);
    this.botonEnable = false;

    this.isSpanish = this.strings.getLanguageIsSpanish();
    this.localeService.use(this.strings.getLanguage());

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    this.TenantId = this.strings.getTenant();
    this.AvailableOrganizations = this.strings.getAvailableOrganizations();
    this.organizationList = this.AvailableOrganizations.filter(Orga => Orga.tenantId == this.TenantId);
    this.organizations = this.organizationList;
    this.validateSession();
    this._route.queryParams.subscribe(params => {
      if (params['startDate'] !== undefined && params['endDate'] !== undefined) {
        this.endDate = new Date(params['endDate']);
        this.startDate = new Date(params['startDate']);
      }

      if (params['organizationid'] !== undefined) {
        this.organizationId = params['organizationid'];
        this.strOrganizationSelected = this.organizationId
        this.organizationSelected = this.organizationList.filter(org => this.organizationId.includes(org.organizationId));
        this.selectedOrganization = this.organizationList;
        this.botonEnable = true;
      }

      if (params['storeid'] !== undefined) {
        this.storeId = Number(params['storeid']);
        this.tmpStoreId = this.storeId;
      }
    });
    this.LoadStores();
  }

  /**
   * Validate the session and permissions.
   */
  validateSession() {
    const permissionsList = this._storage.get('permissions');
    permissionsList.forEach(element => {
      if (element.name === Permissions.MobileAccess) {
        this.hideStores = true;
      }
    });
    const user = this._storage.get('user');
    const userStore = user.storeId;
    if (!isNaN(userStore)) {
      this.storeId = Number(userStore);
      if (this.storeId != -1) {
        this.ImStore = true;

      }
    }
  }

  /**
   * Generate the new alert.
   * 
   * @param message 
   * @param type 
   */
  addAlert(message: String, type: String) {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message
    });
  }

  /**
   * Close the alert.
   * 
   * @param dismissedAlert 
   */
  onClosed(dismissedAlert: AlertComponent) {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

  /**
   * Validate if the user selected a other different store.
   */
  onStoreChange() {
    this.rows = this._filteredData.filter(item => {
      return (item.storeId.toString() === this.storeId.toString());
    });
  }

  /**
   * This event show the manifest details of the row selected.
   * 
   * @param item 
   * @param organizationId 
   */
  detailManifestClick(item, organizationId, participateAvelon, modal) {
    this.loading = true;
    this.titleDelivery = item;
    let language = 0;
    if (!this.isSpanish) {
      language = 1;
    }

    if (!isNullOrUndefined(this.organizations) && !isNullOrUndefined(organizationId)) {
      if (participateAvelon == 1) {
        this.organizationId = organizationId
      }
      else {
        this.organizationId = null;
      }
    }
    // Obtener listado de mercancía a ingresar
    this._facadeShipmentManifest.GetAllByDeliveryCode(item, language, this.organizationId).subscribe(result => {
      if (result.completed) {
        if (result.data.length > 0) {
          this.manifests = result.data;

          if (modal == 'createModal') {
            this.createModal.show();
          }
          else if (modal == 'detailGuides') {
            this.detailGuides.show();
          }
        } else {
          this.addAlert('<strong>' + this.strings.GetText(res.AlertNoDeliveryInfoWasObtained) + '</strong>', 'danger');
        }
        this.loading = false;
      } else {
        this.addAlert('<strong>' + this.strings.GetText(res.AlertErrorGettingInformation) + '</strong>', 'danger');
        this.loading = false;
      }
    }, error => {
      this.addAlert('<strong>' + error + '</strong>', 'danger');
      this.loading = false;
    });
  }

  /**
   * This method generate the view for the details of ware the row selected.
   * 
   * @param deliveryCode 
   * @param organizationId 
   */
  onViewMerchandiseDetail(deliveryCode, organizationId, participateAvelon) {
    if (!isNullOrUndefined(this.organizations) && !isNullOrUndefined(organizationId)) {
      if (participateAvelon == 1) {
        this.organizationId = organizationId
      }
      else {
        this.organizationId = null;
      }
    }
    const navigationExtras: NavigationExtras = {
      queryParams: {
        'startDate': this.startDate.toDateString(),
        'endDate': this.endDate.toDateString(),
        'storeid': this.storeId,
        'organizationid': this.strOrganizationSelected
      }
    };
    this._router.navigate(['/inventory/inventory-entry', deliveryCode], navigationExtras);
  }

  /**
   * This method allow download the data to Excel file.
   */
  downloadLayout() {
    if (this.rows.length > 0) {
      const data: any = [];
      this.rows.forEach(row => {
        const info = {
          [this.strings.GetText(res.Delivery)]: row.deliveryCode,
          [this.strings.GetText(res.Invoice)]: row.invoiceNumber,
          [this.strings.GetText(res.Store)]: row.storeId,
          [this.strings.GetText(res.SendDate)]:
            this.isSpanish
              ? this._datePipe.transform(row.startShipmentDate, 'd MMM y')
              : this._datePipe.transform(row.startShipmentDate, 'MMM d, y'),
          [this.strings.GetText(res.AmountSent)]: row.sent,
          [this.strings.GetText(res.FolioTransferEntryTitle)]: row.sheetNumber,
          [this.strings.GetText(res.ReceivedDate)]:
            this.isSpanish
              ? this._datePipe.transform(row.endShipmentDate, 'd MMM y')
              : this._datePipe.transform(row.endShipmentDate, 'MMM d, y'),
          [this.strings.GetText(res.EntryDate)]:
            this.isSpanish
              ? this._datePipe.transform(row.endDateEntry, 'd MMM y')
              : this._datePipe.transform(row.endDateEntry, 'd MMM, y'),
          [this.strings.GetText(res.AmountEntry)]: row.received,
          [this.strings.GetText(res.DiffAmountSentEntry)]: row.difference,
          ['% ' + this.strings.GetText(res.Received)]: row.percentReception,
          ['% ' + this.strings.GetText(res.Entry)]: row.percentEntryInventory,
          [this.strings.GetText(res.DiffDaysReceivedEntry)]: row.daysDifferenceRI,
          [this.strings.GetText(res.DiffDaysSentReceived)]: row.daysDifferenceSR,
          [this.strings.GetText(res.Status)]: row.typeStatus
        };
        data.push(info);
      });
      this._excel.exportAsExcelFile(data, this.strings.GetText(res.CEDISMerchandiseEntry));
    } else {
      this.addAlert(this.strings.GetText(res.AlertSelectActivityFirst), 'danger');
    }
  }

  /**
   * This a event that trigger when the user change the initial date.
   * 
   * @param value 
   */
  onStartDateChange(value) {
    this.startDate = this.subtractTimeFromDate(value, 6);

    const mes = this.startDate.getMonth();
    this.startDate.setMonth(this.startDate.getMonth() - 1);
    while (this.startDate.getMonth() === mes) {
      this.startDate.setDate(this.startDate.getDate() - 1);
    }

    if (this.startDate > this.endDate) {
      this.addAlert('<strong>!Error¡ ' + this.strings.GetText(res.AlertTheStartDateCannotBeHigher), 'danger')
    }
  }

  /**
   * This a event that trigger when the user change the final date.
   * 
   * @param value 
   */
  onEndDateChange(value) {
    this.endDate = this.subtractTimeFromDate(value, 6);

    const mes = this.endDate.getMonth();
    this.endDate.setMonth(this.endDate.getMonth() - 1);
    while (this.endDate.getMonth() === mes) {
      this.endDate.setDate(this.endDate.getDate() - 1);
    }
  }

  /**
   * This method gets the data to be displayed.
   */
  getByDates() {
    this.loading = true;

    if (new Date(this.startDate) > new Date(this.endDate)) {
      this.addAlert('<strong>Error! </strong>' + this.strings.GetText(res.AlertTheStartDateCannotBeHigher), 'danger');
      this.loading = false;
    }
    else {
      const STATUS = {
        UNKNOWN: this.strings.GetText(res.UnknownStatus),
        COMPLETED: this.strings.GetText(res.CompleteEntry),
        PARTIAL: this.strings.GetText(res.PartialEntry),
        EXPIRATION: this.strings.GetText(res.Expiration),
        WITHOUT_RECEPTION: this.strings.GetText(res.Without_Reception)
      }

      if (this.storeId !== -1) {
        this._facade.GetByDates(this.startDate.toDateString(), this.endDate.toDateString(), this.organizationId, this.storeId)
          .subscribe(result => {
            if (result.completed) {
              result.data.forEach(element => {
                switch (element.appSource) {
                  case 1:
                    if (element.percentReception == 100.00 && element.percentEntryInventory == 100.00) {
                      element.typeStatus = STATUS.COMPLETED;
                      element.colorStatus = COLOR_STATUS.COMPLETED;
                    }
                    else if (element.percentReception > 0.00 || element.percentReception < 100.00) {
                      if (element.percentEntryInventory == 100.00) {
                        if (element.endShipmentDateString == null) {
                          element.typeStatus = STATUS.WITHOUT_RECEPTION;
                          element.colorStatus = COLOR_STATUS.RECEPTION_INCOMPLETE;
                        }
                        else {
                          element.typeStatus = STATUS.PARTIAL;
                          element.colorStatus = COLOR_STATUS.INCOMPLETE;
                        }
                      }
                      else if (element.percentEntryInventory > 0.00 || element.percentEntryInventory < 100.00) {
                        element.typeStatus = STATUS.PARTIAL;
                        element.colorStatus = COLOR_STATUS.DELAY;
                      }
                      else {
                        element.typeStatus = STATUS.EXPIRATION;
                        element.colorStatus = COLOR_STATUS.DELAY;
                      }
                    }
                    break;
                  case 4:
                    element.typeStatus = STATUS.UNKNOWN;
                    element.colorStatus = COLOR_STATUS.WITHOUT_STATUS;
                    break
                  default:
                    element.typeStatus = STATUS.UNKNOWN;
                    element.colorStatus = COLOR_STATUS.WITHOUT_STATUS;
                    break;
                }
              });
              this.rows = result.data;
              this._filteredData = result.data;
              this.loading = false;
            } else {
              this.addAlert('<strong>' + result.message + '</strong>', 'danger');
              this.loading = false;
            }

          }, error => {
            this.addAlert('<strong>' + error + '</strong>', 'danger');
            this.loading = false;
          });
      }
      else {
        this.addAlert(this.strings.GetText(res.AdviceSelectOptionStoreField), 'warning');
        this.loading = false;
      }
    }
  }

  /**
   * Does the filter the data in the rows getting.
   * 
   * @param event 
   */
  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);
    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
      // iterate through each row's column data
      for (let i = 0; i < keys.length; i++) {
        if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
          return true;
        }
      }
    });
  }

  /**
   * This a event that trigger when the user change the organization.
   * 
   * @param selectedOrganization 
   */
  onChangeOrganization(selectedOrganization: any[]) {
    this.selectedOrganization = selectedOrganization;
    this.strOrganizationSelected = this.selectedOrganization
      .map((e) => e.organizationId)
      .join(',');
      
    this.organizationId = this.strOrganizationSelected;
    if (selectedOrganization.length > 0) {
      this.botonEnable = true
    }
    this.LoadStores();
  }

  /**
   * This method gets the information of the stores.
   */
  LoadStores() {
    this.rows = [];
    this._filteredData = [];

    this.strOrganizationSelected = this.selectedOrganization.map(e => e.organizationId).join(',');

    this._facadeStore.GetParticipateQuantum().subscribe(result => {
      if (result.completed) {
        this.stores = result.data.filter(st => this.strOrganizationSelected.includes(st.organizationId));
      }

      if (this.ImStore) {
        this.botonEnable = true;
      }
      else {
        this.hideStores = false;
        this.storeId = this.storeId !== -1 ? this.storeId : -1;
        if (this.tmpStoreId !== -1) {
          this.storeId = this.tmpStoreId;
          this.botonEnable = true;
          this.getByDates();
        }
      }
    });

  }

  subtractTimeFromDate(objDate, intHours) {
    var numberOfMlSeconds = objDate.getTime();
    var addMlSeconds = intHours * 60 * 60000;
    var newDateObj = new Date(numberOfMlSeconds - addMlSeconds);
    return newDateObj;
  }

  /**
   * Open modal to show sheet numbers separated by commas.
   * 
   * @param sheetNumber 
   */
  openSheetNumberModal(sheetNumber: string) {
    this.sheetNumbers = sheetNumber ? sheetNumber.split(',').map(s => s.trim()) : [];
    this.sheetNumberModal.show();
  }
}

export const COLOR_STATUS = {
  WITHOUT_STATUS: 'circle_sinStatus',
  COMPLETED: 'circle_complete',
  INCOMPLETE: 'circle_incomplete',
  RECEPTION_INCOMPLETE: 'circle_reception',
  DELAY: 'circle_delay'
}